// export const ApiConfig = {
//   host: '192.168.1.92:8000',
//   protocol: 'http',
//   apiKey: 'N6275K8n4TIm5D40wErH06f8oYUSpkxR',
//   pathPrefix: '',
// };

// export const StoreApiConfig = {
//   host: '192.168.1.92',
//   protocol: 'http',
//   appKey: '3Rhj5RaWIjfCVjaKPUUNU7qFA1PBvo05i5jux8NOJvdInBAlcvsYc9xT',
//   pathPrefix: '/mlm_projects/05_muhannad_ksa/store/index.php',
// };

export const ApiConfig = {
  host: 'office.wm2.store',
  protocol: 'https',
  apiKey: 'N6275K8n4TIm5D40wErH06f8oYUSpkxR',
  pathPrefix: '',
};

export const StoreApiConfig = {
  host: 'wm2.store',
  protocol: 'https',
  appKey: '3Rhj5RaWIjfCVjaKPUUNU7qFA1PBvo05i5jux8NOJvdInBAlcvsYc9xT',
  pathPrefix: '/index.php',
};
